<template>
  <div style="width: 100%;">
    <swiper
        ref="mySwiper"
        :slides-per-view="1"
        :space-between="50"
        :options="swiperOptions"
        @slideChange="onSlideChange"
        class="swiper"
    >
      <swiper-slide v-for="item in data" :key="item.url">
        <img :src="item.url" />
      </swiper-slide>
      <div class="swiper-pagination "  slot="pagination"></div>
    </swiper>
  </div>

</template>

<script>
import Vue from 'vue'
import 'swiper/swiper-bundle.css'
import { Swiper as SwiperClass, Pagination, Mousewheel, Autoplay } from 'swiper/swiper.esm'
import getAwesomeSwiper from 'vue-awesome-swiper/dist/exporter'
SwiperClass.use([Pagination, Mousewheel, Autoplay])
Vue.use(getAwesomeSwiper(SwiperClass))

const { Swiper, SwiperSlide } = getAwesomeSwiper(SwiperClass)

export default {
  components: {
    Swiper,
    SwiperSlide
  },
  props: {
    data: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  name: "RotationChart",
  data() {
    return {
      swiperOptions: {
        pagination: {
          el: '.swiper-pagination',
          clickable :true,
          bulletClass: 'bullet',
          bulletActiveClass: 'bullet-active'
        },
        autoplay: false,
       /* autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },*/
        effect : 'flip',
        loop: false,
        initialSlide: 0,
        speed: 500,
        grabCursor: true,
      }
    }
  },
  methods: {
    onSlideChange() {
      // console.log(data)
    }
  }
}
</script>

<style lang="less" scoped>
.swiper {
  width: 100%;
  //height: 14.5rem;

  img {
    width: 100%;
    pointer-events: none;
  }
}

</style>

<style lang="less">
.bullet {
  width: 0.6rem;
  height: 0.6rem;
  min-width: 8px;
  min-height: 8px;
  background: #FFF;
  border: 0.05rem solid #333;
  border-radius: 100%;
  display: inline-block;
  margin: 0 0.2rem;
}

.bullet-active {
  background: #333;
}
</style>
